/**
 * SortIcon Component
 * 테이블 헤더에서 정렬 상태를 표시하는 아이콘 컴포넌트
 */
import React from 'react';
import { SortDirection } from '@/shared/hooks/useTableSort';

interface SortIconProps {
    /** 현재 정렬 방향 **/
    direction: SortDirection;
    /** 커스텀 클래스명 **/
    className?: string;
}

/**
 * 정렬 아이콘 컴포넌트
 * FontAwesome 아이콘을 사용하여 정렬 상태를 표시
 *
 * @example
 * ```tsx
 * <SortIcon direction={sortConfig.direction} />
 * ```
 */
const SortIcon: React.FC<SortIconProps> = ({ direction, className = ''}) => {
    return (
        <span className={`sort-icon ${className}`}>
            {direction === 'asc' && <i className="fas fa-sort-up"></i>}
            {direction === 'desc' && <i className="fas fa-sort-down"></i>}
            {!direction && <i className="fas fa-sort" style={{ opacity: 0.3 }}></i>}
        </span>
    );
};

export default SortIcon;

